export const selectTheme = state => state.theme.theme;
export const selectIsLoading = state => state.theme.isLoading;